import { useMutation, useQueryClient } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';

// POST /tickets. Invalida las listas para que la cola refleje el alta.
const useCrearTicket = (headquarter) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => ticketsService.crearTicket({ headquarter, ...body }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tickets', 'lista'] }),
  });
};

export default useCrearTicket;
